<template>
  <div class="charts-container">
    <div class="chart-pie"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: 'ChartsPie',
  props: {
    data1: {
      type: Array,
      required: true,
    },
    data2: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      // 定义颜色数组
      colors: ['#259fff', '#f36067', '#ffc00e', '#c793f2', '#7d63ee', '#45f8ff', '#5fd3fd'],
      // 定义图表名称
      chartName1: 'GPU卡数量占比',
      chartName2: 'GPU卡算力占比',
      chart: null,
    };
  },
  watch: {
    data1: {
      deep: true,
      handler() {
        this.update();
      },
    },
    data2: {
      deep: true,
      handler() {
        this.update();
      },
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.chart = echarts.init(this.$el.querySelector('.chart-pie'));
      window.addEventListener('resize', () => this.chart.resize());
      this.$once('hook:beforeDestroy', () => {
        window.removeEventListener('resize', () => this.chart.resize());
        this.chart.dispose();
      });
      this.update();
    },
    update() {
      if (!this.chart) return;

      const { data1, data2,  colors, chartName1, chartName2 } = this;

      const option = {
        title: {
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
        },
        legend: {
          orient: 'vertical',
          itemGap: 30,
          left: 'center',
          top: 'center',
          itemHeight: 8,
          itemWidth: 8,
          itemShape: 'circle', // 将图例图标改为圆形
          icon: 'circle',
          textStyle: {
             color: "#fff",
              rich: {
                name: {
                  fontSize: 12,
                  color: "#fff",
                  padding: [0, 0, 0, 0],
                  fontFamily: 'OPPOSans R'
                },
                num: {
                  fontSize: 14,
                  fontWeight: 500,
                  padding: [0, 0, 0, 0],
                  color: "#fff"
                }
              }
          },
          data: [...data1.map(item => item.name), ...data2.map(item => item.name)],
        },
        series: [
          // 第一个玫瑰图
          {
            name: chartName1,
            type: 'pie',
            radius: ['25%', '80%'], // 内外半径
            center: ['20%', '40%'], // 中心点位置
            roseType: 'area', // 设置为玫瑰图
            avoidLabelOverlap: false,
            left: '5%',
            top: 0,
            bottom: 0,
            label: {
              show: false,
            },
            data: data1.map((item, index) => ({
              ...item,
              // itemStyle: {
              //   color: colors[index % colors.length], // 循环使用颜色
              // },
            })),
          },
          // 第二个玫瑰图
          {
            name: chartName2,
            type: 'pie',
            radius: ['25%', '80%'], // 内外半径
            center: ['78%', '40%'], // 中心点位置
            roseType: 'area', // 设置为玫瑰图
            avoidLabelOverlap: false,
            right: 0,
            label: {
              show: false,
            },
            data: data2.map((item, index) => ({
              ...item,
              // itemStyle: {
              //   color: colors[index % colors.length], // 循环使用颜色
              // },
            })),
          },
        ],
         graphic: [
          // 第一个玫瑰图标题
          {
            type: 'text',
            left: '18%',
            bottom: '10px',
            z: 100,
            style: {
              text: chartName1,
              textAlign: 'center',
              fill: '#f5f5f5', // 文字颜色
              fontSize: 12,
              fontFamily: '"OPPOSans R",sans-serif',
            },
          },
          // 第二个玫瑰图标题
          {
            type: 'text',
            right: '17%',
            bottom: '10px',
            z: 100,
            style: {
              text: chartName2,
              textAlign: 'center',
              fill: '#f5f5f5', // 文字颜色
              fontSize: 12,
              fontFamily: '"OPPOSans R",sans-serif',
            },
          },
        ]
      };

      this.chart.setOption(option);
    },
  },
};
</script>

<style scoped>
.charts-container {
  display: flex;
  justify-content: center;
}

.chart-pie {
  margin-top: 20px;
  width: 100%; /* 调整宽度以适应两个玫瑰图 */
  height: 160px;
  font-family: 'OPPOSans R';
}
</style>